import { useTranslation } from 'react-i18next';
import { Chip } from '../../components/ui';
import type { PlanLimitKey, PlanUsage } from '../../types/Restaurant';

const KEYS: PlanLimitKey[] = ['locations', 'users', 'languages'];

/** Usage against the plan limits, one row per limit. A null limit means unlimited. */
export const UsageList = ({ usage }: { usage: PlanUsage }) => {
    const { t } = useTranslation('billing');
    return (
        <ul className="grid gap-4">
            {KEYS.map((key) => {
                const max = usage.limits[key];
                const used = usage.usage[key];
                const full = max !== null && used >= max;
                return (
                    <li key={key} className="grid gap-1.5">
                        <div className="flex flex-wrap items-center justify-between gap-2 text-small">
                            <span className="text-strong">{t(`usage.${key}`)}</span>
                            <span className="flex items-center gap-2 tabular-nums text-muted">
                                {full && <Chip variant="action">{t('usage.limitReached')}</Chip>}
                                {max === null ? t('usage.unlimited', { used }) : t('usage.of', { used, max })}
                            </span>
                        </div>
                        {max !== null && (
                            <div aria-hidden="true" className="h-2 overflow-hidden rounded-chip bg-sunken">
                                <div
                                    className={`h-full rounded-chip ${full ? 'bg-accent' : 'bg-inverse'}`}
                                    style={{ width: `${max === 0 ? 100 : Math.min(100, (used / max) * 100)}%` }}
                                />
                            </div>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};
